import { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import Graytextarea from '../../../components/Graytextarea'
import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModalHeader, CModalTitle } from '@coreui/react'
import Select from 'react-select'

const HpiRecords = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, setPatientDBdata, noteID }) => {
  const [fetchingQuestions, setFetchingQuestions] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  const [tempFreeTypeText, setTempFreeTypeText] = useState('')
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [visible, setVisible] = useState(false)
  const [freeTypes, setFreeTypes] = useState({})
  const [dbData, setDbData] = useState({})
  const [subjective, setSubjective] = useState([])
  const [questionsWithDiagnosis, setQuestionsWithDiagnosis] = useState({})
  const [patientFinalNoteHpi, setPatientFinalNoteHpi] = useState({})
  const [saving, setSaving] = useState(false)
  const [selectedDiagnosiToAddFreeTypeRemarks, setSelectedDiagnosiToAddFreeTypeRemarks] = useState('')
  const [loadingSteps, setLoadingSteps] = useState({
    fetchingHpiQuestions: false,
    fetchingQustionBackend: false,
  })
  console.log(patientFinalNoteHpi, 'patientFinalNoteHpi')
  const [patientDiagnosis, setPatientDiagnosis] = useState([])

  const { getHPIDiagnosisData, getAllMasterDiagnosis, getPatientHpi, getProviderDetails, savePatientHpi, getOfflineData, saveOfflineData, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()

  useEffect(() => {
    const patientD = patientDBdata?.patientData?.Diagnosis.split(',')
    setPatientDiagnosis(patientD)
  }, [])

  const getData = async () => {
    // let a = await GetDiagnosisData()
    // let data = JSON.parse(a.d)
    let diagnosisData = await getAllMasterDiagnosis()
    // let diagnosisData = await GetDiagnosisData("");
    diagnosisData = diagnosisData?.Data
    let options = []
    diagnosisData?.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    options?.sort((a, b) => a.label.localeCompare(b.label))

    setDiagnosisData(options)
  }

  useEffect(() => {
    getData()
  }, [])

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]

      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const getQuestionForDiagnosis = async (hpiData = null) => {
    setLoadingSteps((prev) => ({
      ...prev,
      fetchingQustionBackend: true,
    }))

    setFetchingQuestions(true)

    try {
      let diagnosisData = await getAllMasterDiagnosis()
      // let diagnosisData = await GetDiagnosisData('')
      // let diagnosisData = await GetDiagnosisData("");
      diagnosisData = diagnosisData?.Data

      // diagnosisData = JSON.parse(diagnosisData?.d)?.Data || []

      const currentHpiData = hpiData || patientFinalNoteHpi

      const tempIds = patientDBdata?.currentNote?.data?.metadata?.tempIds || []
      const followupIds = patientDBdata?.currentNote?.data?.metadata?.diagnosisIds || []

      const findDiagnosisIids = diagnosisData.filter((item) => patientDiagnosis?.includes(item?.Name))

      const structured = {}
      const freeTypeAllDiagnosis = {}

      if (findDiagnosisIids?.length > 0) {
        await Promise.all(
          findDiagnosisIids.map(async (diagnos) => {
            let questionType = 'HPI'

            if (patientDBdata?.patientData?.Status === 'NewPatient') {
              if (tempIds.includes(diagnos.id) || followupIds.includes(diagnos.id)) {
                questionType = 'HPI'
              }
            } else if (patientDBdata?.patientData?.Status === 'Follow Up') {
              if (tempIds.includes(diagnos.id)) {
                questionType = 'HPI'
              } else if (followupIds.includes(diagnos.id)) {
                questionType = 'followup'
              }
            }

            // let data = await SaveQuestionProvider('GET', '', questionType, diagnos.id, '')

            // data = JSON.parse(data?.d)?.Data || []
            //
            // const questions = data
            //   .map((q) => {
            //     try {
            //       return JSON.parse(q.questionData)
            //     } catch (e) {
            //       return []
            //     }
            //   })
            //   .flat()

            const questions = dbData?.[diagnos.Name]?.[questionType]?.questionData || []

            const answered = Array.isArray(currentHpiData?.[diagnos.Name]) ? currentHpiData[diagnos.Name] : []

            console.log(answered, 'answered here')

            // if (answered.length > 0 && answered[0]?.freewayRemark) {
            //
            //   freeTypeAllDiagnosis[diagnos?.Name] = answered[0]?.freewayRemark || freeTypes[diagnos?.Name] || ''
            // }
            const remark = answered.length > 0 && answered[0]?.freewayRemark ? answered[0].freewayRemark : freeTypes[diagnos?.Name] || ''

            freeTypeAllDiagnosis[diagnos?.Name] = remark

            const updateQuestionsWithAnswer = (questionsList, parentLabel = '') => {
              return questionsList.map((q) => {
                const match = answered.find((a) => a.label === q.label && a.id == q.id)

                const updatedQuestion = {
                  ...q,
                  // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                  historyOfDiagnosis: q?.historyOfDiagnosis || false,
                  freewayRemark: q.freewayRemark || '',
                  answer: match?.answer || '',
                  freeType: match?.freeType || '',
                  parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                }

                if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                  updatedQuestion.options = updatedQuestion.options.map((opt) => {
                    const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

                    if (opt.label === updatedQuestion.answer && linkedQuestions.length > 0) {
                      return {
                        ...opt,
                        linkedQuestion: updateQuestionsWithAnswer(linkedQuestions, updatedQuestion.label),
                      }
                    }

                    return opt
                  })
                }

                return updatedQuestion
              })
            }

            const mergedQuestions = updateQuestionsWithAnswer(questions)
            structured[diagnos.Name] = mergedQuestions
          }),
        )
      }
      console.log(structured, 'structured')

      setFreeTypes(freeTypeAllDiagnosis)
      // setQuestionsWithDiagnosis(structured)
      setQuestionsWithDiagnosis((prev) => {
        const merged = { ...prev }

        Object.entries(structured).forEach(([diagnosisName, questions]) => {
          console.log(!merged[diagnosisName], 'merged with strucurw')
          merged[diagnosisName] = questions
          // if (!merged[diagnosisName]) {
          // merged[diagnosisName] = questions
          // }
        })

        console.log(merged, 'merged here')

        return merged
      })
    } catch (error) {
      console.error('Error in getQuestionForDiagnosis:', error)
    } finally {
      setFetchingQuestions(false)
      setLoadingSteps((prev) => ({
        ...prev,
        fetchingQustionBackend: false,
      }))
    }
  }

  const getQuestionForNewlyDiagnosis = async (selectedDiagnosisIds) => {
    // setFetchingQuestions(true);

    try {
      let diagnosisData = await GetDiagnosisData('')
      diagnosisData = JSON.parse(diagnosisData?.d)?.Data || []

      const tempIds = patientDBdata?.currentNote?.data?.metadata?.tempIds || []
      const followupIds = patientDBdata?.currentNote?.data?.metadata?.diagnosisIds || []

      // Filter diagnosis based on the selected IDs
      const findDiagnosisIids = diagnosisData.filter((item) => selectedDiagnosisIds.includes(item.id))

      const newQuestionsData = {}

      if (findDiagnosisIids?.length > 0) {
        await Promise.all(
          findDiagnosisIids.map(async (diagnos) => {
            let questionType = 'HPI'

            // if (patientDBdata?.patientData?.Status === 'NewPatient') {
            //   if (tempIds.includes(diagnos.id) || followupIds.includes(diagnos.id)) {
            //     questionType = 'HPI';
            //   }
            // } else if (patientDBdata?.patientData?.Status === 'Follow Up') {
            //   if (tempIds.includes(diagnos.id)) {
            //     questionType = 'HPI';
            //   } else if (followupIds.includes(diagnos.id)) {
            //     questionType = 'followup';
            //   }
            // }

            let data = await SaveQuestionProvider('GET', '', questionType, diagnos.id, '')
            data = JSON.parse(data?.d)?.Data || []

            const questions = data
              .map((q) => {
                try {
                  return JSON.parse(q.questionData)
                } catch (e) {
                  return []
                }
              })
              .flat()

            // Get existing answers for this diagnosis if any
            const answered = Array.isArray(patientFinalNoteHpi?.[diagnos.Name]) ? patientFinalNoteHpi[diagnos.Name] : []

            const updateQuestionsWithAnswer = (questionsList, parentLabel = '') => {
              return questionsList.map((q) => {
                const match = answered.find((a) => a.label === q.label && a.id == q.id)
                const updatedQuestion = {
                  ...q,
                  // historyOfDiagnosis: q?.historyOfDiagnosis || undefined,
                  historyOfDiagnosis: q?.historyOfDiagnosis || false,
                  freewayRemark: q.freewayRemark || '',
                  answer: match?.answer || '',
                  freeType: match?.freeType || '',
                  parentQuestion: parentLabel ? `${parentLabel} - ${match?.answer}` : undefined,
                }

                // Handle linked questions for options
                if (updatedQuestion.options?.length > 0 && updatedQuestion.answer) {
                  updatedQuestion.options = updatedQuestion.options.map((opt) => {
                    const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

                    if (opt.label === updatedQuestion.answer && linkedQuestions.length > 0) {
                      return {
                        ...opt,
                        linkedQuestion: updateQuestionsWithAnswer(linkedQuestions, updatedQuestion.label),
                      }
                    }

                    return opt
                  })
                }
                return updatedQuestion
              })
            }

            const mergedQuestions = updateQuestionsWithAnswer(questions)
            newQuestionsData[diagnos.Name] = mergedQuestions
          }),
        )
      }

      // Merge new questions with existing questions
      setQuestionsWithDiagnosis((prevData) => ({
        ...prevData,
        ...newQuestionsData,
      }))
    } catch (error) {
      console.error('Error in getQuestionForNewlyDiagnosis:', error)
    } finally {
      // setFetchingQuestions(false);
    }
  }
  const fetchPatientFinalNoteDetails = async (callback) => {
    setLoadingSteps((prev) => ({
      ...prev,
      fetchingHpiQuestions: true,
    }))

    try {
      // let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      // let allData = JSON.parse(data?.d)
      const allDataPatientHpi = await getPatientHpi()
      // const allPatientHpiData = allData?.Data?.map((item) => {
      const allPatientHpiData = allDataPatientHpi?.Data?.map((item) => {
        return {
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })
      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)

      console.log(result, 'result')

      setSubjective(result[patientID])

      try {
        const hpiData = result?.[patientID]?.[noteID]?.HPI || {}
        const newFreeTypeTextFetched = result?.[patientID]?.[noteID]?.newFreeTypeText || ''

        console.log(hpiData, 'hpiData')

        if (newFreeTypeTextFetched) {
          setNewFreeTypeText(newFreeTypeTextFetched || '')
          setTempFreeTypeText(newFreeTypeTextFetched || '')
        }

        setPatientFinalNoteHpi(hpiData)

        if (typeof callback === 'function') {
          callback(hpiData)
        }

        return hpiData
      } catch (error) {
        console.error('Error setting patient HPI:', error)
        setPatientFinalNoteHpi({})
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingSteps((prev) => ({
        ...prev,
        fetchingHpiQuestions: false,
      }))
    }
  }

  useEffect(() => {
    const fetchHpiAndQuestions = async () => {
      const hpidata = await fetchPatientFinalNoteDetails()

      await getQuestionForDiagnosis(hpidata)
    }
    fetchHpiAndQuestions()
  }, [patientDiagnosis, dbData])

  const collectAllAnsweredQuestionsFromMerged = (questions, parentContext = null, onlyWithHistoryOfDiagnosis = false) => {
    const result = []

    for (const q of questions) {
      const { answer, freeType, label, options = [], id } = q

      const hasAnswer = Array?.isArray(answer) ? answer?.join(',')?.trim() : answer?.trim()

      const hasFreeType = freeType?.trim()
      // Add this question if it has answer or freeType
      // if (hasAnswer || hasFreeType) {
      //     result.push({
      //         label,
      //         answer,
      //         freeType,
      //         freewayRemark: q.freewayRemark || '',
      //         historyOfDiagnosis: q.historyOfDiagnosis || undefined,
      //         parentQuestion: parentContext
      //             ? `${parentContext.label} - ${parentContext.selectedOptionLabel}`
      //             : undefined,
      //     });
      // }
      // Add question if it has an answer, freeType, or isOptionForFreeType is true
      const shouldInclude = (hasAnswer || hasFreeType || q?.isOptionForFreeType || q?.freewayRemark) && (!onlyWithHistoryOfDiagnosis || q?.historyOfDiagnosis === true)

      if (shouldInclude) {
        result.push({
          id,
          label,
          answer,
          freeType,
          freewayRemark: q.freewayRemark || '',
          historyOfDiagnosis: q.historyOfDiagnosis || undefined,
          isOptionForFreeType: q?.isOptionForFreeType || false, // keep this in the result
          parentQuestion: parentContext ? `${parentContext.label} - ${parentContext.selectedOptionLabel}` : undefined,
        })
      }

      // Now check options for linked questions
      for (const opt of options) {
        if (opt.linkedQuestion && opt.linkedQuestion.length > 0) {
          const nestedContext = {
            label: answer,
            selectedOptionLabel: opt.label,
          }
          const nestedResults = collectAllAnsweredQuestionsFromMerged(opt.linkedQuestion, nestedContext)
          result.push(...nestedResults)
        }
      }
    }

    return result
  }

  // const handleSubmit = async () => {
  //

  //   const buildHPIObject = () => {
  //     return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
  //       const collected = collectAllAnsweredQuestionsFromMerged(questions)
  //       if (collected.length > 0) {
  //         acc[key] = collected
  //       }
  //       return acc
  //     }, {})
  //   }

  //   if (parseInt(noteID) === 0) {
  //
  //     const buildNoteStructureHistoryofDiagnosis = () => {
  //       return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
  //         const collected = collectAllAnsweredQuestionsFromMerged(questions)

  //         const filteredQuestions = collected.map((item) => ({
  //           label: item.label,
  //           answer: item.answer,
  //           freeType: item.freeType,
  //           parentQuestion: item.parentQuestion,
  //           originalQuestion: item,
  //         }))

  //         if (filteredQuestions.length > 0) {
  //           acc[key] = filteredQuestions
  //         }

  //         return acc
  //       }, {})
  //     }

  //     const finalHpiForNoteIDZero = buildNoteStructureHistoryofDiagnosis()
  //
  //     if (Object.keys(finalHpiForNoteIDZero).length > 0) {
  //
  //       noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         historyOfDiagnosis: finalHpiForNoteIDZero,
  //       }
  //
  //
  //     }
  //   }
  //   const finalHpi = buildHPIObject()
  //
  //   if (Object.keys(finalHpi).length === 0) {
  //     console.warn('No diagnosis has any answered data. Nothing to save.')
  //     // return;
  //   }

  //   if (noteID === 0) {
  //     const finalHpiStructure = {
  //       [patientID]: {
  //         [noteID]: {
  //           HPI: finalHpi,
  //           medicationRemarksForSubjective: '',
  //           data: '',
  //           newFreeTypeText: newFreeTypeText || '',
  //         },
  //       },
  //     }
  //

  //     await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
  //     setVisible(false)
  //     setQuestionsWithDiagnosis({})
  //     fetchPatientFinalNoteDetails()
  //     await getQuestionForDiagnosis()
  //   } else {
  //     let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
  //     let allData = JSON.parse(data?.d)
  //     const allPatientHpiData = allData?.Data?.map((item) => {
  //       return {
  //         Id: item?.Id,
  //         ...JSON.parse(item?.JsonData),
  //         CreatedAt: item?.CreatedAt,
  //       }
  //     })

  //     if (patientID && Number(noteID)) {
  //       const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
  //       const latestPatientHPISecondTimeNoteWithSubjective = result[patientID]

  //       const finalHpiStructure = {
  //         [patientID]: {
  //           [noteID]: {
  //             HPI: finalHpi,
  //             medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
  //             data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
  //             newFreeTypeText: newFreeTypeText || '',
  //           },
  //         },
  //       }

  //
  //       await SaveExtra('UPDATE', 'PatientHPI', JSON.stringify(finalHpiStructure), result?.Id)
  //       setVisible(false)
  //       fetchPatientFinalNoteDetails()
  //     await getQuestionForDiagnosis()
  //     }
  //   }
  // }

  const [deleteModel, setDeleteModel] = useState(false)
  const [toBeDeletedDiagnosis, setToBeDeletedDiagnosis] = useState('')

  const [deleting, setDeleting] = useState(false)

  const setHpiDataToPatientIndexDb = async (data, type) => {
    const allDataPatientHpi = await getPatientHpi()

    if (!allDataPatientHpi?.Data) return

    const parsedData = allDataPatientHpi.Data.map((item) => ({
      ...item,
      JsonData: JSON.parse(item.JsonData),
      ParsedJson: JSON.parse(item.JsonData),
    }))

    const filtered = parsedData.filter((item) => {
      const patientData = item.ParsedJson?.[patientID]
      return patientData && patientData[noteID]
    })

    const latest = filtered?.at(-1)

    if (type === 'update' && latest !== undefined) {
      const allHpiPatientWithUpdated = parsedData.map((item) => {
        if (item.Id === latest.Id) {
          return {
            ...item,
            hpiStatus: 'to_be_updated',
            JsonData: JSON.stringify(data),
          }
        } else {
          return {
            ...item,
            JsonData: JSON.stringify(item.JsonData),
          }
        }
      })
      if (type === 'delete') {
        await savePatientHpi({ Data: allHpiPatientWithUpdated, IDNumber: '' })
      }
      await savePatientHpi({ Data: allHpiPatientWithUpdated, IDNumber: '' })
    } else {
    }
  }

  const setHistoryOfDiagnosisInCurrentNote = async (data) => {
    //  const offlineDataOfCurrentPatient =  noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : noteCallType === '/provider/pre-signed' ?  await getPreSignedData() :   await getOfflineData()

    //     const providerData = offlineDataOfCurrentPatient?.[loggedUserProvider?.ID] || {};
    //     const patientData = providerData?.[patientID] || {};
    //     const currentNote = patientData?.currentNote || {};
    //     const currentNoteData = currentNote?.data || {};

    //     const allProviderPatientDataWithAddedHOD = {
    //       ...offlineDataOfCurrentPatient,
    //       [loggedUserProvider?.ID]: {
    //         ...providerData,
    //         [patientID]: {
    //           ...patientData,
    //           currentNote: {
    //             ...currentNote,
    //             data: {
    //               ...currentNoteData,
    //               historyOfDiagnosis: data,
    //             },
    //           },
    //         },
    //       },
    //     };

    //
    //     // await saveOfflineData(allProviderPatientDataWithAddedHOD);
    //     noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(allProviderPatientDataWithAddedHOD)  : await saveOfflineData(allProviderPatientDataWithAddedHOD)

    setPatientDBdata((prev) => {
      return {
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev?.currentNote?.data,
            historyOfDiagnosis: data,
          },
        },
      }
    })
  }

  const handleSubmit2 = async () => {
    setSaving(true)

    const buildHPIObject = () => {
      return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
        const collected = collectAllAnsweredQuestionsFromMerged(questions, null, false)
        if (collected.length > 0) {
          acc[key] = collected
        }
        return acc
      }, {})
    }

    if (parseInt(noteID) === 0) {
      const buildNoteStructureHistoryofDiagnosis = () => {
        return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
          const collected = collectAllAnsweredQuestionsFromMerged(questions, null, true)

          const filteredQuestions = collected.map((item) => ({
            label: item.label,
            answer: item.answer,
            freeType: item.freeType,
            parentQuestion: item.parentQuestion,
            originalQuestion: item,
            id: item.id,
          }))

          if (filteredQuestions.length > 0) {
            acc[key] = filteredQuestions
          }

          return acc
        }, {})
      }

      const finalHpiForNoteIDZero = buildNoteStructureHistoryofDiagnosis()

      if (Object.keys(finalHpiForNoteIDZero).length > 0) {
        //
        // noteStructureRef.current = {
        //   ...noteStructureRef.current,
        //   historyOfDiagnosis: finalHpiForNoteIDZero,
        // }
        //
        //
        // await saveTreatsShell(false)
        setHistoryOfDiagnosisInCurrentNote(finalHpiForNoteIDZero)
      }
    }
    const finalHpi = buildHPIObject()

    if (Object.keys(finalHpi).length === 0) {
      console.warn('No diagnosis has any answered data. Nothing to save.')
      // return;
    }

    // let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
    // let allData = JSON.parse(data?.d)
    const allDataPatientHpi = await getPatientHpi()

    const allPatientHpiData = allDataPatientHpi?.Data?.map((item) => {
      return {
        Id: item?.Id,
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    const latestPatientHPISecondTimeNoteWithSubjective = result[patientID]

    if (latestPatientHPISecondTimeNoteWithSubjective) {
      const finalHpiStructure = {
        [patientID]: {
          [noteID]: {
            HPI: finalHpi,
            medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
            data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
            // newFreeTypeText: newFreeTypeText || '',
            newFreeTypeText: tempFreeTypeText || '',
          },
        },
      }
      console.log(finalHpiStructure, 'finalHpiStructure seting')

      // await SaveExtra('UPDATE', 'PatientHPI', JSON.stringify(finalHpiStructure), result?.Id)
      setHpiDataToPatientIndexDb(finalHpiStructure, 'update')
      // setVisible(false)
      // const hpidata = await fetchPatientFinalNoteDetails()
      // await getQuestionForDiagnosis(hpidata)
    } else {
      // let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      // let allData = JSON.parse(data?.d)
      const allDataPatientHpi = await getPatientHpi()
      const allPatientHpiData = allDataPatientHpi?.Data?.map((item) => {
        return {
          Id: item?.Id,
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      if (patientID && Number(noteID)) {
        const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
        const latestPatientHPISecondTimeNoteWithSubjective = result?.[patientID]

        const finalHpiStructure = {
          [patientID]: {
            [noteID]: {
              HPI: finalHpi,
              medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
              data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
              newFreeTypeText: newFreeTypeText || '',
            },
          },
        }

        console.log(finalHpiStructure, 'finalHpiStructure seting')

        // await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
        setHpiDataToPatientIndexDb(finalHpiStructure, 'insert')
        // setVisible(false)
        // const hpidata = await fetchPatientFinalNoteDetails()
        // await getQuestionForDiagnosis(hpidata)
      }
    }
    setSaving(false)
  }

  const [isAddingDiagnosis, setIsAddingDiagnosis] = useState(false)

  const handleAddDiagnosis = async () => {
    setIsAddingDiagnosis(true)

    if (!selectedDiagnosis || selectedDiagnosis.length === 0) {
      console.warn('No diagnosis selected. Please select at least one diagnosis.')
      return
    }
    await addDiagnosisIdsToNote(selectedDiagnosis.map((item) => item.value))
    setSelectedDiagnosis(null)
    await fetchPatientFinalNoteDetails()
    await getQuestionForNewlyDiagnosis(selectedDiagnosis.map((item) => item.value))
    setVisible(false)
    setIsAddingDiagnosis(false)
  }

  const updateAnswerById = (questions, targetId, updater) => {
    return questions.map((q) => {
      if (q.id === targetId) {
        const updated = updater(q)
        return updated
      } else if (q.options?.some((opt) => (Array.isArray(opt.linkedQuestion) && opt.linkedQuestion.length > 0) || (opt.linkedQuestion && !Array.isArray(opt.linkedQuestion)))) {
        let selectedOptions = []
        if (q.isMultiple) {
          const answerArray = q.answer ? q.answer.split('|||').map((v) => v.trim()) : []
          selectedOptions = q.options.filter((opt) => answerArray.includes(opt.label))
        } else {
          selectedOptions = q.options.filter((opt) => opt.label === q.answer)
        }

        return {
          ...q,
          options: q.options.map((opt) => {
            const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

            if (linkedQuestions.length) {
              const isSelectedOption = selectedOptions.some((selected) => selected.label === opt.label)
              if (isSelectedOption) {
                return {
                  ...opt,
                  linkedQuestion: updateAnswerById(linkedQuestions, targetId, updater),
                }
              }
            }

            return opt
          }),
        }
      }

      return q
    })
  }

  const renderQuestion = (item, parentKey, parentIdx, parentPath = []) => {
    const currentPath = [...parentPath, item.id]
    const isTopLevel = parentPath.length === 0

    if (!item.answer && !item.freeType) {
      return
    }

    const selectOptions =
      item.options?.map((opt) => ({
        value: opt.label.trim(),
        label: opt.label.trim(),
      })) || []

    const selectedValues = item?.answer ? item.answer.split('|||').map((v) => v.trim()) : []

    const selectedOptions = item?.isMultiple ? selectOptions.filter((opt) => selectedValues.includes(opt.value)) : selectOptions.find((opt) => opt.value === item.answer) || null
    const selectedText = item?.isMultiple
      ? selectOptions
          .filter((opt) => selectedValues.includes(opt.value))
          .map((opt) => opt.label)
          .join(', ')
      : selectOptions.find((opt) => opt.value === item.answer)?.label || ' '

    console.log('selectedText', selectedText, selectedValues)
    return (
      <div key={item.id} className="mb-3">
        <div className="  mb-2">
          <div className="d-flex gap-1">
            <p className="mb-0">{parentIdx + 1}.</p>
            <CFormLabel className="mb-0">{item.label}</CFormLabel>
          </div>

          {item.type === 'dropdown' && (
            <input
              type="text"
              className="form-control mt-2"
              value={(item.answer || '').replace(/\|\|\|/g, ', ')}
              style={{ width: '100%', minHeight: '20px', background: '#2D2D2D', border: 0, color: 'white' }}
              onChange={(e) => {
                const val = e.target.value

                setQuestionsWithDiagnosis((prevData) => {
                  const newData = { ...prevData }
                  newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, answer: val }))
                  return newData
                })
              }}
            />
          )}
        </div>

        {item.type === 'input' && (
          <Graytextarea
            onBlur={handleSubmit2}
            type="text"
            className="form-control mt-2"
            value={item.answer || ''}
            style={{ width: '100%', minHeight: '20px', background: '#2D2D2D', border: 0, color: 'white' }}
            onChange={(e) => {
              const val = e.target.value

              setQuestionsWithDiagnosis((prevData) => {
                const newData = { ...prevData }
                newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, answer: val }))
                return newData
              })
            }}
            placeholder="Enter your text"
          />
        )}

        {item.providerInfo && (
          <p className="mt-2" style={{ color: 'yellow' }}>
            {item.providerInfo}
          </p>
        )}

        {/* Linked Questions */}
        {item.options?.map((opt) => {
          const answerArr = selectedValues
          const isSelected = answerArr.includes(opt.label.trim())

          const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

          return (
            isSelected &&
            linkedQuestions.length > 0 && (
              <div key={`${opt.label}-${item.id}`} className="ml-3 mt-3 border-start ps-3">
                {linkedQuestions.map((nestedItem, nestedIdx) => renderQuestion(nestedItem, parentKey, nestedIdx, currentPath))}
              </div>
            )
          )
        })}

        {isTopLevel && (
          <div className="mt-2">
            <Graytextarea
              value={item.freeType || ''}
              onBlur={handleSubmit2}
              onChange={(e) => {
                const val = e.target.value

                setQuestionsWithDiagnosis((prevData) => {
                  const newData = { ...prevData }
                  newData[parentKey] = updateAnswerById(newData[parentKey], item.id, (q) => ({ ...q, freeType: val }))
                  return newData
                })
              }}
              style={{ width: '100%', minHeight: '80px', background: '#2D2D2D', border: 0, color: 'white' }}
              placeholder="Freetype"
            />
          </div>
        )}
      </div>
    )
  }

  useEffect(() => {
    const fetchHPIMasterFromDB = async () => {
      const data = await getHPIDiagnosisData()

      setDbData(data)
    }
    fetchHPIMasterFromDB()
  }, [])

  const handleDelete = async () => {
    setDeleting(true)

    const buildHPIObject = () => {
      return Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
        const collected = collectAllAnsweredQuestionsFromMerged(questions, null, false)
        if (collected.length > 0) {
          acc[key] = collected
        }
        return acc
      }, {})
    }

    const finalHpi = buildHPIObject()

    if (Object.keys(finalHpi).length === 0) {
      console.warn('No diagnosis has any answered data. Nothing to save.')
      // return;
    }

    // let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
    // let allData = JSON.parse(data?.d)
    // const allPatientHpiData = allData?.Data?.map((item) => {
    //   return {
    //     Id: item?.Id,
    //     ...JSON.parse(item?.JsonData),
    //     CreatedAt: item?.CreatedAt,
    //   }
    // })
    const allDataPatientHpi = await getPatientHpi()
    const allPatientHpiData = allDataPatientHpi?.Data?.map((item) => {
      return {
        Id: item?.Id,
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
    const latestPatientHPISecondTimeNoteWithSubjective = result[patientID]

    delete finalHpi[toBeDeletedDiagnosis]

    if (latestPatientHPISecondTimeNoteWithSubjective) {
      const finalHpiStructure = {
        [patientID]: {
          [noteID]: {
            HPI: finalHpi,
            medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.medicationRemarksForSubjective || '',
            data: latestPatientHPISecondTimeNoteWithSubjective?.[noteID]?.data || '',
            newFreeTypeText: newFreeTypeText || '',
          },
        },
      }

      // await SaveExtra('UPDATE', 'PatientHPI', JSON.stringify(finalHpiStructure), result?.Id)
      setHpiDataToPatientIndexDb(finalHpiStructure, 'delete')
      setVisible(false)
      const hpidata = await fetchPatientFinalNoteDetails()
      setVisible(false)

      await deletePatientDiagnosis(patientID, toBeDeletedDiagnosis?.toString(), 'Submitted')
      setDeleting(false)

      setQuestionsWithDiagnosis((prev) => {
        const updated = { ...prev }
        delete updated[toBeDeletedDiagnosis]
        return updated
      })
      setPatientDiagnosis((prev) => prev.filter((item) => item !== toBeDeletedDiagnosis))

      setDeleteModel(false)
      setToBeDeletedDiagnosis('')
      setDeleting(false)
    }
  }

  const renderView = () => {
    return (patientDiagnosis || []).map((diagnosisItem) => {
      const hpiData = patientFinalNoteHpi?.[diagnosisItem] || []

      if (!hpiData.length) return null

      const freeTypeRemark = hpiData[0]?.freewayRemark ? <div style={{ paddingLeft: 10, color: '#444' }}>{hpiData[0].freewayRemark}</div> : null

      return (
        <div key={diagnosisItem} style={{ marginBottom: 10 }}>
          <p style={{ margin: 0, fontWeight: 700, lineHeight: '22px', fontSize: '11pt' }}>{diagnosisItem.toUpperCase()}</p>

          {freeTypeRemark}

          {hpiData.map((hpi, idx) => {
            const label = hpi?.label || ''
            const answer = Array.isArray(hpi?.answer) ? hpi.answer.join(', ') : hpi?.answer?.split('|||').join(', ') || ''

            const parentQuestion = hpi?.parentQuestion?.split('-')[1] || ''

            return (
              <div key={idx} style={{ paddingLeft: 10, marginBottom: 10 }}>
                <span>
                  {parentQuestion && `[${parentQuestion}] `}

                  {label ? (
                    <>
                      <span style={{ fontWeight: 700 }}>{label}</span> : {answer}
                    </>
                  ) : (
                    answer
                  )}
                </span>

                {hpi?.freeType && <div>Freetype : {hpi.freeType}</div>}
              </div>
            )
          })}
        </div>
      )
    })
  }

  return (
    <div className="d-flex align-items-start ">
      <div style={{ minWidth: '23%' }}>HPI</div>
      <div className="d-flex flex-column gap-3 w-100">
        {newFreeTypeText && <Graytextarea style={{ width: '100%', height: '80px', background: '#2D2D2D', border: 0, color: 'white' }} value={tempFreeTypeText} onChange={(e) => setTempFreeTypeText(e.target.value)} />}
        {Object.entries(questionsWithDiagnosis)
          //   .filter(([key, value]) => !(value[0]?.isOptionForFreeType)) // <-- skip if true
          .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
          .map(([key, value], index) => {
            console.log(key, value, 'key, value')
            const hasFreeType = Boolean(freeTypes?.[key])

            const hasAnsweredItems = value?.some((item) => item?.answer || item?.freeType)

            if (!hasFreeType && !hasAnsweredItems) return null

            return (
              <div key={index} alwaysOpen>
                <div itemKey={1}>
                  <div>
                    <div className="d-flex justify-content-between align-items-center gap-2 w-100">
                      <p className="p-0 m-0">{key}</p>
                      <div>
                        <span
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            setDeleteModel(true)
                            setToBeDeletedDiagnosis(key)
                          }}
                          style={{
                            marginRight: '10px',
                          }}
                          className="text-danger"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div className="" style={{}}>
                    {freeTypes[key] && (
                      <input
                        className="form-control mt-2"
                        style={{ width: '100%', minHeight: '20px', background: '#2D2D2D', border: 0, color: 'white' }}
                        value={freeTypes[key]}
                        onBlur={handleSubmit2}
                        onChange={(e) => {
                          const freeTypeRemarksText = e.target.value
                          setFreeTypes((prev) => ({
                            ...prev,
                            [key]: freeTypeRemarksText,
                          }))

                          // setSelectedDiagnosiToAddFreeTypeRemarks('')
                          // setFreeTypeRemarksText('')

                          setQuestionsWithDiagnosis((prevData) => {
                            const newData = { ...prevData }

                            if (!Array.isArray(newData[key])) {
                              newData[key] = []
                            }

                            if (newData[key].length > 0) {
                              newData[key][0].freewayRemark = freeTypeRemarksText
                            } else {
                              // Create default object based on your shared structure
                              newData[key].push({
                                id: Date.now(),
                                label: '',
                                answer: '',
                                condition: null,
                                type: 'text',
                                isMultiple: false,
                                toolTipValue: '',
                                options: [],
                                freeType: '',
                                showFreeTypeInAssessment: false,
                                freewayRemark: freeTypeRemarksText,
                                isOptionForFreeType: true,
                              })
                            }

                            return newData
                          })
                        }}
                      />
                    )}
                    {value
                      .filter((item) => !item?.isOptionForFreeType)
                      .map((item, idx) => {
                        if (!item.answer && !item.freeType) {
                          return
                        }
                        return renderQuestion(item, key, idx)
                      })}

                    {value.length === 0 && !freeTypes[key] && (
                      <div className="d-flex justify-content-start align-items-center text-muted" style={{ height: '50px' }}>
                        <div
                          style={{
                            fontSize: '15px',
                            fontWeight: '600px',
                            color: 'gray',
                          }}
                        >
                          No Data Available
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        {/* <p>{subjective[noteID]?.data}</p> */}
        <textarea className="form-control" style={{ width: '100%', minHeight: '20px', background: '#2D2D2D', border: 0, color: 'white' }} value={subjectiveData} onChange={(e) => setSubjectiveData(e.target.value)} onBlur={handleSubjectiveBlur} />
      </div>
    </div>
  )
}

export default HpiRecords
